import axios from "axios";

const lisapropApiUrl =
  process.env.NODE_ENV === "development"
    ? "https://api.lisaprop.xyz/api"
    : "https://api.lisaprop.africa/api/";
const lisapropApi = axios.create({
  baseURL: lisapropApiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

export { lisapropApi, lisapropApiUrl };
